export default __webpack_public_path__ + "static/media/user-nobg.062dea91.svg";